import SimpleGrid from "@ui-kit/layout/Grid/SimpleGrid.web";
import Stack from "@ui-kit/layout/Stack/Stack.web";
import Skeleton from "@shared/components/ui-kit/feedback/Skeleton/Skeleton.web";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";

const DonationsSkeleton: React.FC = () => {
  return (
    <Box p="xl" w="full" data-testid="donations-skeleton">
      <Flex justifyContent="space-between" direction="column">
        {/* Header Skeleton */}
        <Box width="100%" maxWidth="100%">
          <Skeleton height="element.xl" width="120px" />
        </Box>

        {/* Cause Details Skeleton */}
        <Box mt="md">
          <Stack spacing={2}>
            <Skeleton height="element.lg" width="60%" />
            <Skeleton height="element.md" width="80%" />
            <Skeleton height="element.md" width="40%" />
          </Stack>
        </Box>

        {/* Donation Input Skeleton */}
        <Box mt="4xl">
          <Skeleton height="element.lg" width="180px" mb="md" />
          <SimpleGrid columns={[2, null, 4, null, 8]} spacing={4}>
            {Array.from({ length: 5 }, (_, i) => (
              <Skeleton
                key={`donation-skeleton-${i}`}
                height="element.2xl"
                borderRadius="sm"
              />
            ))}
          </SimpleGrid>
          <Skeleton height="element.md" width="200px" mt="sm" />
        </Box>

        {/* Footnotes Skeleton */}
        <Box mt="md" mb={{ base: "4", sm: "none" }}>
          <Stack spacing={1}>
            <Skeleton height="element.md" width="90%" />
            <Skeleton height="element.md" width="85%" />
          </Stack>
        </Box>
      </Flex>
    </Box>
  );
};

export { DonationsSkeleton };
